import consumer from "./consumer";

let currentUserId = document.querySelector("body").getAttribute("data-current-user-id");

window.subscribeToUnderlyingsProgressChannel = function (currentUserId) {
    if (!consumer.subscriptions.findAll('UnderlyingsProgressChannel', currentUserId).length) {
        consumer.subscriptions.create({channel: "UnderlyingsProgressChannel", user_id: currentUserId}, {

            connected() {
                // Called when the subscription is ready for use on the server
                console.log("connected to UnderlyingsProgressChannel")
            },

            disconnected() {
                // Called when the subscription has been terminated by the server
            },

            received(data) {
                // Called when there's incoming data on the websocket for this channel
                const feedbackElement = $("#lookthrough-process-feedback").closest("pre");
                const isScrolledToBottom = feedbackElement.scrollTop() + feedbackElement.innerHeight() >= feedbackElement[0].scrollHeight;

                if (data.progress) {
                    console.log(data.progress);
                    feedbackElement.append('<br>' + data.progress);

                    // Scroll to the bottom if already at the bottom before appending new content
                    if (isScrolledToBottom) {
                        feedbackElement.scrollTop(feedbackElement[0].scrollHeight);
                    }
                }

                if (data.error) {
                    $("#lookthrough-loading").addClass("d-none");
                    feedbackElement.append('<br>' + data.error);
                }

                if (data.done) {
                    $("#lookthrough-done").html(data.done);
                    $("#lookthrough-loading").addClass("d-none");
                    $(`#asset_${data.fund_id} .${data.quarter}`).append("<i class=\"bi bi-exclamation-circle-fill  text-warning\"></i>");
                }
            }
        });
    }
}